import { jwtDecode } from 'jwt-decode';
import { getToken } from '../slice/token'
import { RootState } from '../store'

export const checkToken = async (store: any) => {
    const state = store.getState() as RootState
	const token = state.token.token;

	let decoded = null

	try {
		decoded = jwtDecode(token);
	} catch(e) {
		console.log(e)
		return null
	}
    
	const currentTime = Date.now() / 1000;

	if (decoded && decoded?.exp && (decoded.exp < currentTime)) {
		let res = await store.dispatch(getToken())
		return res?.payload?.token
	} else {
		return token
	}
};

export const getCookie = (name: string) => {
	if (document?.cookie) {
		try {
			const value = `; ${document.cookie}`;
			const parts = value.split(`; ${name}=`);
			if (parts && parts.length === 2) {
				let plop = parts.pop()
		
				if (plop) {
					plop = plop.split(';').shift();
					return plop
				}
			}
		} catch(e) {
			console.log(e)
			return null
		}
	}

	return null
}

export const generateUUID =  () => {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	  const r = Math.random() * 16 | 0; // Génère un nombre aléatoire entre 0 et 15
	  const v = c === 'x' ? r : ((r & 0x3) | 0x8); // Utilise 0x8 ou 0x9, 0xA ou 0xB pour 'y'
	  return v.toString(16); // Convertit le nombre en hexadécimal
	});
}

export const addDays = (date: any, days: number) => {
	const result = new Date(date);
	result.setDate(result.getDate() + days);
	return result;
}
